/**
 * `strokeWidth` values that render as a 1.5px hairline at the 22px mobile-nav
 * icon size, which is what the Figma tab bar and More sheet specify.
 *
 * `strokeWidth` is measured in viewBox units, so the number depends on the grid
 * the icon was drawn on: lucide uses 24, the local `partner/icons` set uses 16.
 * Without this the two families sit side by side at 1.83px and 2.06px.
 */
const MOBILE_NAV_ICON_PX = 22;
const HAIRLINE_PX = 1.5;

/** For lucide-react icons (24-unit grid, default `strokeWidth` 2). */
export const NAV_STROKE_LUCIDE = (HAIRLINE_PX * 24) / MOBILE_NAV_ICON_PX;

/** For the local `partner/icons` set (16-unit grid, default `strokeWidth` 1.5). */
export const NAV_STROKE_LOCAL = (HAIRLINE_PX * 16) / MOBILE_NAV_ICON_PX;
